import React from 'react';

import { theme } from 'antd';

import { EpdDocumentKind, EpdState } from '@app/models/orders';
import { useEpdStateName } from '@app/services/hooks/useEpdStateName';
import { StatusTag } from '@components/StatusTag';

interface IProps {
  state: EpdState;
  kind?: EpdDocumentKind;
}

export const EpdStatusTag: React.FC<IProps> = ({ state, kind }) => {
  const stateName = useEpdStateName(kind);
  const { token } = theme.useToken();
  const color =
    state === EpdState.Error
      ? token.colorError
      : state === EpdState.Completed
      ? token.colorSuccess
      : [EpdState.NeedsData, EpdState.RevokeNeedsSigner].includes(state)
      ? token.colorWarning
      : [EpdState.Cancelled, EpdState.Revoked].includes(state)
      ? token.colorTextSecondary
      : token.colorPrimary;
  return <StatusTag color={color} name={stateName(state)} />;
};
